import React from 'react';
import ReactDatePicker, { DatePickerProps } from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import './DatePicker.scss'; // Import scss after react-date-picker for proper styling order (overriding base rules)

export const ClearIcon = <i className="fa-solid fa-times" />;

export function DatePicker(props: DatePickerProps) {
    const showCalendarClear = props.value ? ClearIcon : null;

    return (
        <ReactDatePicker
            calendarIcon={null}
            clearIcon={showCalendarClear}
            clearAriaLabel="Clear Date"
            locale="en-US"
            {...{ value: null, ...props }}
        />
    );
}
